import React from 'react';
import CommissionList from '../components/partner-network/CommissionList';

const CommissionsPage: React.FC = () => <CommissionList />;

export default CommissionsPage;
